import { Grid } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { observer } from "mobx-react";
import { useClosingCoordinatorStore } from "../hooks/useClosingCoordinatorStore";
import { ClosingAgreedLoansGridV2 } from "../../closingAgreedLoans/components/closingAgreedLoansGridV2";
import { CLOSING_COORDINATOR_COLUMNS } from "./closingCoordinatorColumns";

const useStyles = makeStyles(() => ({
  container: {
    minHeight: '750px',
  },
}))

export const ClosingTomorrowGrid = observer(() => {
  const classes = useStyles();
  const { closingCoordinatorStore } = useClosingCoordinatorStore();

  return (
    <Grid container className={classes.container}>
      <ClosingAgreedLoansGridV2
        columns={CLOSING_COORDINATOR_COLUMNS}
        store={closingCoordinatorStore.closingNextBusinessDayGridStore}
      />
    </Grid>
  )
})
